
import { v4 as uuidv4 } from 'uuid';
import {
    createAsyncThunk,
    createEntityAdapter,
    createSlice
  } from '@reduxjs/toolkit'


const adapter = createEntityAdapter({
    selectId: (entity) => entity.id,
});


const localStore = window.localStorage;

function createCreateEntityAsync(entityType) {

    return createAsyncThunk(
        `${entityType}/createStatus`,
        async (entity) => {
            const data = { ...entity, id: uuidv4() };
            return data;
        }
    );
    
}


function createUpdateEntityAsync(entityType) {
    return createAsyncThunk(
        `${entityType}/updateStatus`,
        async (entity) => {
            return entity;
        }
    );
}

function createRemoveEntityAsync(entityType) {
    return createAsyncThunk(
        `${entityType}/removeStatus`,
        async (entity) => {
            return entity.id;
        }
    );

}

function createFetchAllEntities(entityType) {
    return createAsyncThunk(
        `${entityType}/fetchStatus`,
        async (unusedArg, { rejectWithValue }) => {
            // console.log("createFetchAllEntities", entityType, unusedArg)

            return {}; // result will be filled in by the extraReducer
        }
    );
}

// same as in rest adapter
function createEntitySlice(type, actions, options) {

    const persist = options.localStore;

    const entitySlice = createSlice({
        name: type,
        initialState: adapter.getInitialState(),
        reducers: {
            create(state, action) {
                console.log("adding one")
                adapter.addOne(state, action.payload)
            },
            update(state, action) {
                console.log("updating one")
                adapter.updateOne(state, { id: action.payload.id, changes: action.payload });
            },
            upsert(state, action) {
                console.log("upserting one")
                adapter.upsertOne(state, action.payload)
            },
            remove: adapter.removeOne,
            setAll: adapter.setAll,
        },

        extraReducers: (builder) => {
            builder
                .addCase(actions.updateEntityAsync.fulfilled, (state, action) => {
                    adapter.upsertOne(state, action.payload);
                    if (persist) localStore.setItem(type, JSON.stringify(state.entities));
                })
                .addCase(actions.updateEntityAsync.rejected, (_state, action) => {
                    console.log("UPDATE ENTITY REJECTED", action)
                })
                .addCase(actions.createEntityAsync.fulfilled, (state, action) => {
                    adapter.addOne(state, action.payload);
                    if (persist) localStore.setItem(type, JSON.stringify(state.entities));
                })
                .addCase(actions.createEntityAsync.rejected, (_state, action) => {
                    console.log("CREATE ENTITY REJECTED", action)
                })
                .addCase(actions.removeEntityAsync.fulfilled, (state, action) => {
                    adapter.removeOne(state, action.payload);
                    if (persist) localStore.setItem(type, JSON.stringify(state.entities));
                })
                .addCase(actions.removeEntityAsync.rejected, (_state, action) => {
                    console.log("REMOVE ENTITY REJECTED", action)
                })
                .addCase(actions.fetchAllEntities.fulfilled, (state) => {
                    const raw = persist ? localStore.getItem(type) : null;
                    const items = raw ? JSON.parse(raw) : state.entities;
                    adapter.setAll(state, items);
                })
                .addCase(actions.fetchAllEntities.rejected, (state, action) => {
                    console.log("FETCH ALL REJECTED", state, action)
                });
        }
    });
    return entitySlice;
}


export class OfflineEntityAdapter {
    /**
     * 
     * @param {*} type 
     * @param {*} options selectId (@see options in createEntityAdapter)
     *   options.localStore true|false Stores the entities in localStore (TODO)
     */
    constructor(type, options={} ) {
        this.type = type;
        this.options = options;
        this.adapter = createEntityAdapter(options);
        this.actions = {
            createEntityAsync: createCreateEntityAsync(this.type),
            updateEntityAsync: createUpdateEntityAsync(this.type),
            removeEntityAsync: createRemoveEntityAsync(this.type),
            fetchAllEntities: createFetchAllEntities(this.type),
        };
        this.slice = createEntitySlice(type, this.actions, options);
    }

    get reducer() {
        return this.slice.reducer;
    }

    get selectors() {
        return this.adapter.getSelectors();
    }


}